import React from 'react';

export { UserInformations };

function UserInformations() {
    return (
        <div>
            <h1>
                <p>Hi! I am User Info.</p>
            </h1>
            <br />
        </div>
    );
}
